<div class="wrap">
  <h2>Alert logs</h2>

  <div class="filtersExportContainer">
    <form
      [formGroup]="filterAlertForm"
      (submit)="onFilterAlerts()"
      class="filterAlertForm"
    >
      <mat-form-field appearance="outline" class="fromDate">
        <mat-label>Enter a period</mat-label>
        <mat-date-range-input [rangePicker]="alertPicker">
          <input
            matStartDate
            formControlName="from"
            placeholder="From"
            (focus)="alertPicker.open()"
          />
          <input
            matEndDate
            formControlName="to"
            placeholder="To"
            (focus)="alertPicker.open()"
          />
        </mat-date-range-input>
        <!-- <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint> -->
        <mat-datepicker-toggle
          matSuffix
          [for]="alertPicker"
        ></mat-datepicker-toggle>
        <mat-date-range-picker #alertPicker></mat-date-range-picker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>State </mat-label>
        <mat-select formControlName="state">
          <mat-option *ngFor="let etat of etats" [value]="etat">
            {{ etat.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <button
        mat-icon-button
        type="submit"
        color="primary"
        [disabled]="
          filterAlertForm.pristine ||
          !filterAlertForm.value.from ||
          !filterAlertForm.value.to
        "
        matTooltip="Filter"
      >
        <mat-icon> search </mat-icon>
      </button>

      <button
        mat-icon-button
        color="primary"
        *ngIf="!filterAlertForm.pristine"
        matTooltip="Clear the filters"
        (click)="clearFiltersAlerts()"
      >
        <mat-icon> clear </mat-icon>
      </button>
    </form>

    <button
      *ngIf="filterAlertForm.value.from && filterAlertForm.value.to"
      mat-raised-button
      color="primary"
      matTooltip="Export in excel"
      (click)="exportAlertLogs()"
      [disabled]="isExportingAlerts"
    >
      Export
    </button>
  </div>

  <section
    class="alertsSection"
    [hidden]="isLoading || alerts?.length === 0 || !alerts"
  >
    <table
      class="alertsTable"
      mat-table
      [dataSource]="dataSourceAlerts"
      matSort
      (matSortChange)="onSortChangedAlerts($event)"
      [hidden]="isLoading"
    >
      <ng-container matColumnDef="date">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="cell_label"
          mat-sort-header
        >
          Date
        </th>
        <td mat-cell *matCellDef="let element" class="cell_label">
          {{ element.date | date : "short" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="camera">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="cell_action"
          mat-sort-header
        >
          Camera
        </th>
        <td mat-cell *matCellDef="let element" class="cell_action">
          {{ element.camera.name }}({{ element.camera.externalId }})
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="cell_label"
          mat-sort-header
        >
          Alert level
        </th>
        <td mat-cell *matCellDef="let element" class="alertLevelCell">
          {{ element.status }}
        </td>
      </ng-container>

      <ng-container matColumnDef="etat">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="cell_label"
          mat-sort-header
        >
          State
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.state }}
        </td>
      </ng-container>

      <ng-container matColumnDef="modifiedBy">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="cell_label"
          mat-sort-header
        >
          Modified by
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.modifiedBy }}
        </td>
      </ng-container>

      <ng-container matColumnDef="modifiedOn">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="cell_label"
          mat-sort-header
        >
          Modified on
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.modifiedOn | date : "short" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="location">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="cell_action"
          mat-sort-header
        >
          Location
        </th>
        <td mat-cell *matCellDef="let element" class="cell_action">
          {{ element.location }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsAlerts"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsAlerts"></tr>
    </table>
    <mat-paginator
      *ngIf="paginationAlerts"
      [pageSize]="paginationAlerts.pageSize"
      [length]="paginationAlerts.totalRecords"
      [pageIndex]="paginationAlerts.pageNumber - 1"
      (page)="onPageChangedAlerts($event)"
      showFirstLastButtons
    ></mat-paginator>
  </section>

  <section
    class="resultsSection"
    *ngIf="!isLoadingAlerts && alerts?.length === 0 && alerts !== null"
  >
    <p>No alert on that date.</p>
  </section>
  <mat-spinner
    *ngIf="isLoadingAlerts"
    [diameter]="35"
    color="primary"
    class="spinner"
  ></mat-spinner>

  <!-- USER LOGINS -->
  <h2>User logins</h2>

  <div class="filtersExportContainer">
    <form
      [formGroup]="filterLoginsForm"
      (submit)="onFilter()"
      class="filterLoginsForm"
    >
      <mat-form-field appearance="outline" class="fromDate">
        <mat-label>Enter a period</mat-label>
        <mat-date-range-input [rangePicker]="loginsPicker">
          <input
            matStartDate
            formControlName="from"
            placeholder="From"
            (focus)="loginsPicker.open()"
          />
          <input
            matEndDate
            formControlName="to"
            placeholder="To"
            (focus)="loginsPicker.open()"
          />
        </mat-date-range-input>
        <mat-datepicker-toggle
          matSuffix
          [for]="loginsPicker"
        ></mat-datepicker-toggle>
        <mat-date-range-picker #loginsPicker></mat-date-range-picker>
      </mat-form-field>

      <button
        mat-icon-button
        type="submit"
        color="primary"
        [disabled]="
          filterLoginsForm.pristine ||
          !filterLoginsForm.value.from ||
          !filterLoginsForm.value.to
        "
        matTooltip="Filter"
      >
        <mat-icon> search </mat-icon>
      </button>

      <button
        mat-icon-button
        color="primary"
        *ngIf="!filterLoginsForm.pristine"
        matTooltip="Clear the filters"
        (click)="clearLoginsFilters()"
      >
        <mat-icon> clear </mat-icon>
      </button>
    </form>

    <button
      *ngIf="filterLoginsForm.value.from && filterLoginsForm.value.to"
      mat-raised-button
      color="primary"
      matTooltip="Export in excel"
      (click)="exportUserLogins()"
      [disabled]="isExportingUserLogins"
    >
      Export
    </button>
  </div>

  <section
    class="userLoginsSection"
    [hidden]="isLoadingUserLogins || userLogins?.length === 0 || !userLogins"
  >
    <table
      class="userLoginsTable"
      mat-table
      [dataSource]="dataSourceUserLogins"
      matSort
      (matSortChange)="onSortChanged($event)"
    >
      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Username</th>
        <td mat-cell *matCellDef="let order">{{ order.user.username }}</td>
      </ng-container>

      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
        <td mat-cell *matCellDef="let order">
          {{ order?.date | date : "dd/MM/YYYY HH:mm" }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsUserLogins"></tr>
      <tr
        mat-row
        *matRowDef="let mission; columns: displayedColumnsUserLogins"
        class="mission"
      ></tr>
    </table>
    <mat-paginator
      *ngIf="paginationUserLogins"
      [pageSize]="paginationUserLogins.pageSize"
      [length]="paginationUserLogins.totalRecords"
      [pageIndex]="paginationUserLogins.pageNumber - 1"
      (page)="onPageChanged($event)"
      showFirstLastButtons
    ></mat-paginator>
  </section>

  <section
    class="resultsSection"
    *ngIf="
      !isLoadingUserLogins && userLogins?.length === 0 && userLogins !== null
    "
  >
    <p>No user logins on that date.</p>
  </section>
  <mat-spinner
    *ngIf="isLoadingUserLogins"
    [diameter]="35"
    color="primary"
    class="spinner"
  ></mat-spinner>

  <!-- ANPR logs -->
  <h2>ANPR logs</h2>

  <div class="filtersExportContainer">
    <form
      [formGroup]="filterAnprCallsForm"
      (submit)="onFilterAnprCalls()"
      class="filterAnprCallsForm"
    >
      <mat-form-field appearance="outline" class="fromDate">
        <mat-label>Enter a period</mat-label>
        <mat-date-range-input [rangePicker]="anprCallPicker">
          <input
            matStartDate
            formControlName="from"
            placeholder="From"
            (focus)="anprCallPicker.open()"
          />
          <input
            matEndDate
            formControlName="to"
            placeholder="To"
            (focus)="anprCallPicker.open()"
          />
        </mat-date-range-input>
        <!-- <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint> -->
        <mat-datepicker-toggle
          matSuffix
          [for]="anprCallPicker"
        ></mat-datepicker-toggle>
        <mat-date-range-picker #anprCallPicker></mat-date-range-picker>
      </mat-form-field>

      <button
        mat-icon-button
        type="submit"
        color="primary"
        [disabled]="
          filterAnprCallsForm.pristine ||
          !filterAnprCallsForm.value.from ||
          !filterAnprCallsForm.value.to
        "
        matTooltip="Filter"
      >
        <mat-icon> search </mat-icon>
      </button>

      <button
        mat-icon-button
        color="primary"
        *ngIf="!filterAnprCallsForm.pristine"
        matTooltip="Clear the filters"
        (click)="clearFiltersAnprCalls()"
      >
        <mat-icon> clear </mat-icon>
      </button>
    </form>

    <button
      *ngIf="filterAnprCallsForm.value.from && filterAnprCallsForm.value.to"
      mat-raised-button
      color="primary"
      matTooltip="Export in excel"
      (click)="exportAnprCallsLogs()"
      [disabled]="isExportingAnprCalls"
    >
      Export
    </button>
  </div>

  <section
    class="anprCallsSection"
    [hidden]="isLoading || anprCalls?.length === 0 || !anprCalls"
  >
    <table
      class="anprCallsTable"
      mat-table
      [dataSource]="dataSourceAnprCalls"
      matSort
      (matSortChange)="onSortChangedAnprCalls($event)"
      [hidden]="isLoading"
    >
      <ng-container matColumnDef="client">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="cell_label"
          mat-sort-header
        >
          Client
        </th>
        <td mat-cell *matCellDef="let element" class="cell_label">
          {{ element.client.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="date">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="cell_label"
          mat-sort-header
        >
          Date
        </th>
        <td mat-cell *matCellDef="let element" class="cell_label">
          {{ element.date | date : "short" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="user">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="cell_action"
          mat-sort-header
        >
          User
        </th>
        <td mat-cell *matCellDef="let element" class="cell_action">
          {{ element.user.username }}
        </td>
      </ng-container>

      <ng-container matColumnDef="imageName">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="cell_label"
          mat-sort-header
        >
          Image name
        </th>
        <td mat-cell *matCellDef="let element" class="alertLevelCell">
          {{ element.imageName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="numberPlate">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="cell_label"
          mat-sort-header
        >
          Number plate
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.numberPlate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="textDetected">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="cell_label"
          mat-sort-header
        >
          Text detected
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.textDetected }}
        </td>
      </ng-container>

      <ng-container matColumnDef="resultName">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="cell_label"
          mat-sort-header
        >
          Result name
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.resultName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="userAnswer">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="cell_action"
          mat-sort-header
        >
          User answer
        </th>
        <td mat-cell *matCellDef="let element" class="cell_action">
          {{ element.userAnswer }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsAnprCalls"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsAnprCalls"></tr>
    </table>
    <mat-paginator
      *ngIf="paginationAlerts"
      [pageSize]="paginationAnprCalls.pageSize"
      [length]="paginationAnprCalls.totalRecords"
      [pageIndex]="paginationAnprCalls.pageNumber - 1"
      (page)="onPageChangedAnprCalls($event)"
      showFirstLastButtons
    ></mat-paginator>
  </section>

  <section
    class="resultsSection"
    *ngIf="!isLoadingAnprCalls && anprCalls?.length === 0 && anprCalls !== null"
  >
    <p>No ANPR call on that date.</p>
  </section>
  <mat-spinner
    *ngIf="isLoadingAnprCalls"
    [diameter]="35"
    color="primary"
    class="spinner"
  ></mat-spinner>
</div>
